import { defineAction } from '~/prix'
import { z } from 'zod'
import ruralPropertyCreateAction from './ruralPropertyCreate.action.json' assert { type: 'json' }
import { ruralPropertyUpsertInputObject } from '../ruralPropertyObject'

const ruralPropertyCreateDefinition = defineAction({
  ...ruralPropertyCreateAction,

  input: ruralPropertyUpsertInputObject,
  output: z.object({
    id: z.string().uuid(),
  }),
})

export default ruralPropertyCreateDefinition
